// services/dashboardService.js
import axios from "axios";
import { Base_URL } from "../url";
export const fetchPDashboardData = async (filters, user, token) => {
  return axios.get(`${Base_URL}/ProjectViewDashboard/projects`, {
    params: {
      OrganisationID: user?.organisation_id,   // from auth
      CompanyCode: filters.companyCode || null,
      FiscalYear: filters.fiscalYear || null,
      FiscalMonth: filters.fiscalMonth || null
    },
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

